/**
 * Creates query strings. Copied from gcc util to avoid adding an additional dependency.
 *
 * @see https://github.snei.sony.com/SNEI/grand-central-core/blob/af41dd59abe566e165b7b5d229952c7261c696dd/src/core/utilities.js#L19
 */
var createQueryString = function createQueryString() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stringifyArrays = _ref.stringifyArrays,
      stringifyArrays = _ref$stringifyArrays === void 0 ? false : _ref$stringifyArrays,
      _ref$omitQuestionMark = _ref.omitQuestionMark,
      omitQuestionMark = _ref$omitQuestionMark === void 0 ? false : _ref$omitQuestionMark;

  var keys = Object.keys(obj).filter(function (key) {
    return obj[key] != null && obj[key] !== '';
  });

  if (!keys.length) {
    return '';
  }

  var queryString = keys.map(function (key) {
    var value = obj[key];
    var encodedKey = encodeURIComponent(key);
    var encodedValue = Array.isArray(value) && !stringifyArrays ? value.map(encodeURIComponent).join("&".concat(encodedKey, "=")) : encodeURIComponent(value);
    return "".concat(encodedKey, "=").concat(encodedValue);
  }).join('&');
  return (omitQuestionMark ? '' : '?') + queryString;
};

export default createQueryString;